<template>
  <v-container style="margin-top: -10px">
    <v-form
      ref="form"
      lazy-validation
      class="app-form"
      @submit.prevent="onSubmit"
    >
      <v-expansion-panels class="app-expansion-panels">
        <v-expansion-panel>
          <v-expansion-panel-header class="app-expansion-panel-header mb-0">
            <h4 class="text">
              <v-icon>filter_alt</v-icon>
              <span>Filtrar Solicitações</span>
            </h4>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="app-expansion-panel-content">
            <v-row class="mt-3">
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-text-field
                  v-model="table.paginate.numeroSolicitacao"
                  clearable
                  label="Número"
                  placeholder="Ex:. 12345"
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-text-field
                  v-model="table.paginate.cpf"
                  clearable
                  label="CPF"
                  placeholder="Ex:. 000.000.000-00"
                  v-mask="'###.###.###-##'"
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-select
                  v-model="table.paginate.situacao"
                  :items="table.dadosFilterSolicitacao.listSituacao"
                  item-text="nome"
                  item-value="id"
                  clearable
                  label="Status"
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" sm="6" md="4" lg="3">
                <v-select
                  v-model="table.paginate.tipoSolicitacaoId"
                  :items="table.dadosFilterSolicitacao.listTipoSolicitacao"
                  item-text="descricao"
                  item-value="id"
                  clearable
                  label="Tipo"
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" sm="6" md="3" lg="2">
                <v-text-field
                  v-model="table.paginate.loteId"
                  clearable
                  label="Lote"
                  placeholder="Ex:. 12345"
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" sm="12" md="6" lg="4">
                <InputRangeDatePicker
                  @startDate="(valor)=>onChangeData(valor, 'dataInicio')"
                  @endDate="(valor)=>onChangeData(valor, 'dataFim')"
                  :datesFormat="datesFormat"
                />
              </v-col>
            </v-row>

            <div class="mt-3 d-flex actions-row">
              <v-spacer />
              <v-btn
                outlined
                color="error"
                type="button"
                class="mr-2"
                @click.prevent.stop="clearFilter"
              >
                <v-icon size="14">delete</v-icon>
                Limpar Filtros
              </v-btn>
              <v-btn depressed color="primary" type="submit">
                Filtrar
              </v-btn>
            </div>
            <div id="endForm" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import InputRangeDatePicker from "@/components/InputRangeDatePicker.vue";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import EntidadeService from "@/services/sie-pedidos/entidade.service";

const actions = mapActions("siePedidos", [
  "setTableContent",
  "setTableIsLoading",
  "setTableTotals",
  "clearTable",
  "setDadosFilterSolicitacao",
]);
const state = mapState("siePedidos", ["table"]);

export default {
  components: {
    InputRangeDatePicker,
  },
  data: () => ({
    datesFormat: null,
  }),
  computed: {
    ...state,
  },
  mounted() {
    EntidadeService.getDadosFilterSolicitacao().subscribe((response) => {
      this.setDadosFilterSolicitacao(response.result);
    });
  },
  methods: {
    onChangeData(valor, item) {
      const paginate = this.table.paginate;
      this.table.paginate[item] = FunctionsCommuns.formatDate(valor);
      const dataFinal = paginate.dataFim
        ? `~ ${FunctionsCommuns.formatBRDate(paginate.dataFim)}`
        : "";
      this.datesFormat = paginate.dataInicio
        ? `${FunctionsCommuns.formatBRDate(paginate.dataInicio)} ${dataFinal}`
        : null;
    },
    async onSubmit() {
      await this.search();
      this.$vuetify.goTo("#endForm");
    },
    clearFilter() {
      this.datesFormat = null;
      this.clearTable();
      this.search();
    },
    search() {
      this.setTableIsLoading(true);
      EntidadeService.getLista(this.table.paginate).subscribe(
        ({ result }) => {
          this.setTableContent(result?.data);
          this.setTableTotals(result.totalElements);
          this.setTableIsLoading(false);
        },
        () => {
          this.setTableIsLoading(false);
        }
      );
    },
    ...actions,
  },
};
</script>

<style scoped>
/* Ajusta espaçamento dos campos */
.app-expansion-panel-content .v-col {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Botões responsivos */
@media (max-width: 600px) {
  .actions-row {
    flex-direction: column;
    align-items: stretch !important;
  }

  .actions-row .v-btn {
    width: 100%;
    margin: 4px 0 !important;
  }
}
</style>
